import request from "@/utils/request";
import { IDeliveryNoteModel, IDeliveryNoteStateModel } from "./types";
import download from "@/utils/download";
import exp from "constants";

const defaultDeliveryNoteStateData: IDeliveryNoteStateModel = {
  desc: null,
  name: null
};

export const defaultDeliveryNoteData: IDeliveryNoteModel = {
  id: null,
  code: null,
  inStateDesc: null,
  outStateDesc: null,
  sellerName: null,
  purchaserName: null,
  logisticsClerkName: null,
  storageLayerNames: null,
  companyCode: null,
  customerCode: null,
  customerName: null,
  remark: null,
  maxVolume: null,
  createdAt: null,
  lastReleaseTime: null,
  estimatedSailingSchedule: null,
  daysInStock: null,
  reserved: null,
  // estimatedInStorageDateEnd: null,
  // estimatedInStorageDateStart: null,
  // estimatedNextDeliveryDate: null,
  allStorageLayerList: null,
  inState: defaultDeliveryNoteStateData,
  outState: defaultDeliveryNoteStateData,
  canUpload: null,
  customerAbbreviation: null,
  popoverVisible: false
};


export const getDeliveryNote = (id: string) =>
  request({
    url: `/delivery-notes/${id}`,
    method: "get"
  });

export const getDeliveryNotes = (params: any) =>
  request({
    url: "/delivery-notes",
    method: "get",
    params
  });

export const exportDeliveryNotes = (params: any) => {
  download({
    responseType: "blob",
    url: "/delivery-notes/excel",
    method: "get",
    params
  });
};

export const deleteDeliveryNote = (id: string) =>
  request({
    url: `/delivery-notes/${id}`,
    method: "delete"
  });

export const createDeliveryNote = (data: any) =>
  request({
    url: `/delivery-notes`,
    method: "post",
    data
  });

export const addRemark = (id: string, data: { remark: string }) =>
  request({
    url: `/delivery-notes/${id}/remark`,
    method: "put",
    data
  });

export const updateSailingSchedule = (id: string, data: { estimatedSailingSchedule: string }) =>
  request({
    url: `/delivery-notes/${id}/sailing-schedule`,
    method: "put",
    data
  });

export const updateStorageLayers = (id: string, data: { storageLayerIds: string[] }) =>
  request({
    url: `/delivery-notes/${id}/storage-layer`,
    method: "put",
    data
  });

export const getStorageLayers = (deliveryNoteId: string) =>
  request({
    url: `/delivery-notes/${deliveryNoteId}/storage-layers`,
    method: "GET"
  });

export const cancelReserved = (id: string) =>
  request({
    url: `/delivery-notes/reserved/${id}`,
    method: "delete"
  });

export const getDeliveryNoteStateList = () =>
  request({
    url: `/delivery-note-states`,
    method: "get"
  });


export const getHqPackingLists = (deliveryNoteId: string, params: any) =>
  request({
    url: `/delivery-notes/${deliveryNoteId}/hq-packing-lists`,
    method: "get",
    params
  });


export const getDeliveryNotePackages = (deliveryNoteId: string, params: { hqPackingListCode?: string, customsPackingCode?: string }) =>
  request({
    url: `/${deliveryNoteId}/hq-packing-lists/packages`,
    method: "GET",
    params
  });

export const updateMaxVolume = (id:string, data:any)  =>
    request({
        url: `/delivery-notes/${id}/max-volume`,
        method: "PUT",
        data
    })

// /delivery-notes/{code}?customerId=""
// 模糊查询进仓单号码--指定进仓单
export const getDeliveryNotesCode = (code,customerId) =>
  request({
    url: `/delivery-notes/${code}/customers/${customerId}`,
    method: "GET"
  });

  // /delivery-note/storage/remove
  export const postRemove = (data) =>
    request({
      url: `/delivery-note/storage/remove`,
      method: "post",
      data
    });

